
import { defineComponent, inject, computed, unref } from "vue";
import {
  DASHBOARD_MOVE_CONTROLS_KEY,
  DashboardMoveControlsApi,
} from "@/utils/dashboardLayout";

export default defineComponent({
  name: "DashboardMoveControls",
  props: {
    variant: {
      type: String,
      default: "default",
      validator: (value: string) => ["default", "on-dark"].includes(value),
    },
  },
  setup(props) {
    const controls = inject<DashboardMoveControlsApi | null>(
      DASHBOARD_MOVE_CONTROLS_KEY,
      null
    );

    return {
      hasControls: computed(() => Boolean(controls)),
      canMoveUp: computed(() => Boolean(controls && unref(controls.canMoveUp))),
      canMoveDown: computed(() => Boolean(controls && unref(controls.canMoveDown))),
      moveUp: () => controls?.moveUp(),
      moveDown: () => controls?.moveDown(),
      variantClass: computed(() =>
        props.variant === "on-dark"
          ? "seq-dashboard-movable__actions--on-dark"
          : ""
      ),
    };
  },
});
